if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
          this.BISfun()
        });
    }

    setInnerHTML(element, html) {
      // TRUST BOUNDARY: `html` here is first-party section markup rendered by
      // Shopify (the Quick Add product section), not user-supplied input. The
      // script re-injection below deliberately re-enables those first-party
      // <script> tags (innerHTML-inserted scripts don't execute). Do NOT pass
      // untrusted/remote HTML to this method — it would allow script execution.
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
        element.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }


    BISfun(){
      this.modalContent.querySelectorAll("variant-radios input[type='radio']").forEach((e) => {
        e.addEventListener("change", (event)=> {
            let seletced_option = event.target.classList.contains("disabled");
            if(seletced_option == true){
              this.modalContent.querySelector(".matat-backin-stock-alert").classList.add("active");
              this.modalContent.querySelector(".product-form__submit").classList.add("hidden");
            }else{
              this.modalContent.querySelector(".product-form__submit").classList.remove("hidden");
              this.modalContent.querySelector(".matat-backin-stock-alert").classList.remove("active");
            }
        })
      })
      if(this.modalContent.querySelector(".matat-stock-notify-submit")){
        this.modalContent.querySelector(".matat-stock-notify-submit").addEventListener("click", ()=> {
      document.getElementById('phoneValidationMsg').textContent = '';  
      let check_phone = this.validatePhoneNumber();
      if (check_phone) {
                  // Get data attributes from the button
                  const button = this.modalContent.querySelector(".matat-stock-notify-submit");
                  const data = {
                      product_id: button.getAttribute("data-product_id"),
                      action: button.getAttribute("data-action"),
                      id: button.getAttribute("data-id"),
                      title: (button.getAttribute("data-title")),
                      price_varies: (button.getAttribute("data-price_varies")),
                      price: (button.getAttribute("data-price")),
                      price_max: (button.getAttribute("data-price_max")),
                      price_min: (button.getAttribute("data-price_min")),
                      has_only_default_variant: (button.getAttribute("data-has_only_default_variant")),
                      src: button.getAttribute("data-src"),
                      url: button.getAttribute("data-url"),
                      variant_id: button.getAttribute("data-variant-id"),
                      phone: document.getElementById("stock-phone").value, // Assuming there's an input for the phone number
                      user_id: button.getAttribute("data-user_id")
                  };
    
                  fetch('https://shopify-wishlist.matat.io/api/oos', {
                      method: 'POST', 
                      headers: {
                          'Content-Type': 'application/json'
                      },
                      body: JSON.stringify(data)
                  })
                  .then(response => {
                      if (!response.ok) {
                          throw new Error('Network response was not ok');
                      }
    
                  })
                  .then(data => {
                    this.modalContent.querySelector('#phoneValidationMsg').style.color = "green"
                    this.modalContent.querySelector('#phoneValidationMsg').textContent = 'אנו נחזור אליך בהקדם האפשרי, תודה ששלחת';  
                  })
                  .catch(error => {
                      console.error('Error:', error);
                  });
      } else {
        this.modalContent.querySelector('#phoneValidationMsg').textContent = "'מספר טלפון לא תקין.";
      }
      })  
      }
      if(this.modalContent.querySelector('[name="id"]')){
        this.modalContent.querySelector('[name="id"]').addEventListener("change",(e)=>{
          let variant_change_val = e.target.value;
          if(this.modalContent.querySelector(".matat-stock-notify-submit")){
            this.modalContent.querySelector(".matat-stock-notify-submit").setAttribute("data-variant-id",variant_change_val);
            this.modalContent.querySelector(".matat-stock-notify-submit").setAttribute("data-id",variant_change_val);
           }
        })
      }
      
    }
   validatePhoneNumber() {
      // Get and trim phone number input
      const phoneNumber = document.getElementById('stock-phone').value.trim();
  
      // Regex pattern for 10-digit phone number
      const pattern = /^\d{10}$/;
  
      // Validate phone number and update message
      const isValid = pattern.test(phoneNumber);
      return isValid;
    }
  });
}
